<template>
  <div id="registerAppliance">
    <div style="width: 90%">
      <patternlib-headline
        :headline="$t('registerAppliance.headline')"
        separator="none"
        heading-tag="h2"
      ></patternlib-headline>
      <div style="width: 100%" v-if="!serialnumber || !designation">
        <p style="margin-top: var(--spacing-5)">
          {{ $t('registerAppliance.text') }}
        </p>
        <patternlib-textinput
          :label="$t('registerAppliance.serialnumberOfAppliance')"
          style="margin-top: var(--spacing-6); max-width: 708px"
          :error-text="$t('registerAppliance.applianceNotFound')"
          :status="serialnumberStatus"
          @lhChange="(e) => (serialnumber = e.detail.value)"
        ></patternlib-textinput>
        <patternlib-link
          :label="$t('registerAppliance.whereDoIFindSerialnumber')"
          uppercase="false"
          style="margin-top: var(--spacing-4)"
          @click="showModal = true"
        />
        <!-- Conformation of Modal via Patrick -->
        <patternlib-modal
          :modal-title="$t('registerAppliance.modal.title')"
          :show="showModal"
          hide-cancel="true"
          :confirm-label="$t('registerAppliance.modal.moreInfo')"
          confirm-type="secondary"
          @lhClose="showModal = false"
          @lhConfirm="redirectTypelabelPage"
          img-position="left"
          ><!--TODO: @lhConfirm redirection-->
          <span
            slot="modal-content"
            v-html="$t('registerAppliance.modal.infoText')"
          ></span>
          <patternlib-image
            width="100%"
            object-fit="contain"
            slot="modal-content"
            src="../assets/img/serialnumber.jpg"
          />
        </patternlib-modal>
        <patternlib-button
          id="registerApplianceButton"
          :label="$t('registerAppliance.registerAppliance')"
          style="margin-top: var(--spacing-6)"
          :loading="loading"
          @click="loadApplianceData()"
        ></patternlib-button>
      </div>
      <div style="width: 100%" v-if="serialnumber && designation">
        <p style="margin-top: var(--spacing-6)">
          <b>{{ $t('registerAppliance.foundAppliance') }}</b>
        </p>
        <div
          id="grayBox"
          style="
            max-width: 708px;
            background-color: var(--color-steel-50);
            margin-top: var(--spacing-4);
            padding: var(--spacing-6) var(--spacing-6);
          "
        >
          <patternlib-list id="desktopList" no-separator>
            <patternlib-list-item>
              <span>{{ $t('appliance.designation') }}</span>
              <span slot="value">{{ designation }}</span>
            </patternlib-list-item>
            <patternlib-list-item>
              <span>{{ $t('appliance.serialnumber') }}</span>
              <span slot="value">{{ serialnumber }}</span>
            </patternlib-list-item>
          </patternlib-list>
          <div id="mobileList">
            <p>
              <b>{{ $t('appliance.designation') }}</b>
            </p>
            <p style="margin-top: var(--spacing-xxxs)">{{ designation }}</p>
            <p style="margin-top: var(--spacing-5)">
              <b>{{ $t('appliance.serialnumber') }}</b>
            </p>
            <p style="margin-top: var(--spacing-xxxs)">{{ serialnumber }}</p>
          </div>
        </div>
        <p style="margin-top: 64px">
          <b>{{ $t('registerAppliance.giveDesignation') }}</b>
        </p>
        <patternlib-textinput
          :label="$t('registerAppliance.applianceName')"
          style="margin-top: var(--spacing-4); max-width: 708px"
          :placeholder="nickname"
          maxlength="40"
          :warning-text="$t('modalAppliance.lengthNickname')"
          :error-text="$t('modalAppliance.noSpecialChars')"
          :status="nicknameState"
          @lhChange="
            (ev) => {
              nicknameState =
                ev.detail.value.length > 40 || ev.detail.value.length <= 0
                  ? 'warning'
                  : ev.detail.value.match(/[^a-z|^A-Z|^ÄÖÜäöü|^\s]/, ' ')
                  ? 'error'
                  : 'default';
              nickname = ev.detail.value.replace(
                /[^a-z|^A-Z|^ÄÖÜäöü|^\s]/g,
                ' '
              );
            }
          "
        />
        <patternlib-button
          id="saveApplianceButton"
          :label="$t('registerAppliance.saveAppliance')"
          style="margin-top: var(--spacing-4)"
          :loading="loading"
          @click="registerAppliance"
          :disabled="nicknameState == 'default' ? false : true"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { useServices } from '../services/useServices';
  import { useGlobal } from '../stores/globalStore';

  export default {
    data: () => ({
      loading: false,
      designation: '',
      serialnumber: '',
      nickname: '',
      nicknameState: 'warning',
      serialnumberStatus: '',
      showAlreadyExists: false,
      showModal: false
    }),

    methods: {
      loadApplianceData() {
        this.serialnumberStatus = 'default';
        this.loading = true;
        const services = useServices();
        services.$api.getApplianceInfo((data) => {
          this.loading = false;
          if (data == null) {
            this.serialnumberStatus = 'error';
            return;
          }
          this.serialnumber = data.serialnumber;
          this.designation = data.designation;
        }, this.serialnumber);
      },

      registerAppliance() {
        this.loading = true;
        const services = useServices();
        const globalStore = useGlobal();
        services.$api.addAppliance(
          (msg) => {
            // console.log(msg)
            this.loading = false;
            if (msg == 'created') {
              globalStore.registeredApplianceAvailable = true;

              this.$emit('showMessage', {
                type: 'success',
                autoHide: true,
                delay: 15000,
                showIcon: true,
                message: this.$t('registerAppliance.success')
              });

              this.$router.push('/myAppliances');
              return;
            }
            if (msg == 'existing') {
              this.$emit('showMessage', {
                autoHide: true,
                delay: 15000,
                message: this.$t('registerAppliance.applianceExisting')
              });
              this.$router.push('/myAppliances');
              return;
            }
            this.$emit('showMessage', {
              type: 'alert',
              showIcon: true,
              autoHide: true,
              delay: 15000,
              message: this.$t('unknownError')
            });
          },
          this.serialnumber,
          this.nickname
        );
      },

      redirectTypelabelPage() {
        window.location.href = import.meta.env.VITE_APP_TYPELABEL_PAGE_URL;
      }
    }
  };
</script>

<style lang="scss" scoped>
  #registerAppliance {
    display: flex;
    align-items: center;
    flex-direction: column;

    width: 100%;
  }

  #mobileList {
    display: none;
  }

  @media only screen and (max-width: 770px) {
    #registerApplianceButton,
    #saveApplianceButton {
      display: block;
      width: 100%;
    }

    #desktopList {
      display: none;
    }

    #mobileList {
      display: block;
    }

    #grayBox {
      padding: var(--spacing-5) var(--spacing-4) !important;
    }
  }
</style>
